export default function () {
    return {
        trees: [],
        subscription: null,
        payMethod: null
    }
}